export default __webpack_public_path__ + "static/media/03-ponente-conferencia.454dc1ba.png";